import type { MarketResearchDemandAnalysisSearchTrendsAnomaliesListParams } from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";
import { useKeywordListsNodeAPIQueryParams } from "app/pages/market-research/hooks/useKeywordListsNodeAPIQueryParams";

export const useAnomalyDates = () => {
    const params = useKeywordListsNodeAPIQueryParams();
    const anomaliesRelevant = params.keywordListIds.length === 1 && params.compareFrom == undefined;

    const {
        keywordListIds,
        compareFrom: _compareFrom,
        compareTo: _compareTo,
        clusterizationType: _clusterizationType,
        isMonthToDate: _isMonthToDate,
        ...sharedSearchTrendParams
    } = params;

    const response = useApiQuery(
        {
            tag: "DemandSearchTrends",
            methodName: "marketResearchDemandAnalysisSearchTrendsAnomaliesList",
            options: {
                enabled: anomaliesRelevant,
            },
        },
        {
            ...sharedSearchTrendParams,
            keywordListId: keywordListIds[0],
        } satisfies MarketResearchDemandAnalysisSearchTrendsAnomaliesListParams,
    );

    return anomaliesRelevant ? response.data?.anomalies?.map((anomaly) => anomaly.date) : [];
};
